/**
 * WordPress Dependencies.
 */
import domReady from '@wordpress/dom-ready';
import { registerPlugin } from '@wordpress/plugins';
import { TextControl } from '@wordpress/components';
import { PluginDocumentSettingPanel } from '@wordpress/edit-post';

import { __ } from '@wordpress/i18n';
import { useDispatch, useSelect } from '@wordpress/data';

domReady( () => {
	registerPlugin( 'tokengate-token-button-classname', {
		render: () => {
			const metaKey = 'tokengate-button-classname';

			const currentTokenAddress = useSelect( ( select ) => {
				const postMeta = select( 'core/editor' ).getEditedPostAttribute(
					'meta'
				);
				return metaKey in postMeta ? postMeta[ metaKey ] : '';
			} );
			const { editPost } = useDispatch( 'core/editor' );

			const handleAddressChange = ( newAddress ) => {
				editPost( {
					meta: {
						[ metaKey ]: newAddress,
					},
				} );
			};

			return (
				<PluginDocumentSettingPanel
					icon={ () => null }
					title={ __( 'Button Classname', 'wp-token-gate' ) }
					name="wptokengate-token-address-panel"
					className="wptokengate-token-address-panel"
				>
					<TextControl
						onChange={ handleAddressChange }
						value={ currentTokenAddress }
						placeholder={ __( 'Add Class...', 'wp-token-gate' ) }
						help={ __(
							'This classname will be added on the main app verification button.',
							'wp-token-gate'
						) }
					/>
				</PluginDocumentSettingPanel>
			);
		},
	} );
} );
